import React from 'react';
import styled from 'styled-components';
import SeriesItem from './SeriesItem';
import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import { IseriesItem } from '@typings/posting/series.interface';
import { getPathKey } from '@utils/getPath';
import { scrollbarStyle } from '@styles/variants/scrollbar';

const EmptySeriesSec = styled.div`
  width: 100%;
  height: 120px;
  color: var(--subTextColor);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleSec = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--lineColor);
  padding: 16px;
  margin-bottom: 8px;

  h5 {
    margin-bottom: 4px;
  }

  b {
    color: var(--subTextColor);
  }
`;

const ListWrap = styled.div`
  padding: 8px 8px 24px 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;

  overflow-x: hidden;
  ${scrollbarStyle}
`;
type Props = {
  setDocId: any;
  seriesId: string;
};
function SeriesList({ setDocId, seriesId }: Props) {
  const collectionPath = getPathKey(1);

  const { data: seriesData } = useDocument<IseriesItem>(
    `${collectionPath}Series/${seriesId}`,
    { listen: true },
  );

  const { data: list } = useCollection<IseriesItem>(`${collectionPath}Series`, {
    listen: true,
    orderBy: ['order', 'asc'],
  });

  if (!list) {
    return (
      <EmptySeriesSec>해당 게시글과 연결된 시리즈가 없습니다.</EmptySeriesSec>
    );
  }
  return (
    <>
      {seriesId ? (
        <TitleSec>
          <h5>{seriesData?.value}</h5>
          <b>총 {list.length}화</b>
        </TitleSec>
      ) : (
        <TitleSec>
          <h5>전체 시리즈 목록</h5>
          <span style={{ color: 'var(--subTextColor)' }}>현재 게시글은 시리즈가 설정되지 않았습니다.</span>
        </TitleSec>
      )}
      <ListWrap>
        {list.map((item, i) => {
          return (
            <SeriesItem
              key={item.id}
              seriesData={item}
              setDocId={setDocId}
              isActive={item.id === seriesId}
            />
          );
        })}
      </ListWrap>
    </>
  );
}

export default React.memo(SeriesList);
